import React, { Fragment, useState } from "react"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import ActionBar from "../../components/ActionBar"
import {
  Button,
  Icon,
  IconButton,
  Hidden,
  Fab,
  Menu,
  Zoom,
  Paper,
  TextField,
  MenuItem,
} from "@material-ui/core"
import AddIcon from "@material-ui/icons/Add"
import CalendarIcon from "@material-ui/icons/CalendarToday"
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted"
import AutoComplete from "../../components/AutoComplete"

const CustomActionBar = ({ activeCompany, classes, ...props }) => {
  const [searchMenuAnchorEl, setSearchMenuAnchorEl] = useState(null)

  const handleOpenSearchMenu = event => {
    setSearchMenuAnchorEl(event.currentTarget)
  }
  const handleCloseSearchMenu = () => {
    setSearchMenuAnchorEl(null)
  }

  return (
    <ActionBar
      buttonChildren={() => {
        return (
          <Fragment>
            <Hidden smDown>
              {/* CREATE NEW SHOOT */}
              {activeCompany && (
                <div style={{ display: "flex" }}>
                  <Hidden smDown>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={() => props.toggleShootDialog(true)}
                    >
                      + New Shoot
                    </Button>
                    {/* <AutoComplete
                      value={props.search}
                      className={classes.searchShootsAutocomplete}
                      showValue
                      placeholder="Search Shoots"
                      onChange={id => props.shootSelected(id)}
                      labelKey="name"
                      // isDisabled={!context.inCompany}
                      prop={props.props}
                    /> */}
                  </Hidden>
                  <Hidden mdUp>
                    <div style={{ marginLeft: 12 }}>
                      <Fab
                        size="medium"
                        color="primary"
                        aria-label="add"
                        onClick={() => props.toggleShootDialog(true)}
                      >
                        <AddIcon style={{ color: "white" }} />
                      </Fab>
                    </div>
                  </Hidden>
                </div>
              )}
              {/* FILTER BY DATE */}
              {/* {!props.isCalendarView && (
              <DateFilter
                setState={e => props.setDateFilter(e)}
                dateFilter={props.dateFilter}
                setDate={props.setDate}
              />
            )} */}
            </Hidden>
          </Fragment>
        )
      }}
      sortChildren={() => {
        return (
          <div className={classes.sortChildrenWrapper}>
            {/* CALENDAR / CARD VIEW TOGGLE */}
            <div className={classes.calendarToggleView}>
              <IconButton
                aria-label="toggle"
                onClick={props.toggleCalendarView}
              >
                <div className={classes.toggleZoomWrapper}>
                  <Zoom in={props.isCalendarView}>
                    <FormatListBulletedIcon
                      className={classes.calendarToggleIcon}
                    />
                  </Zoom>
                  <Zoom in={!props.isCalendarView}>
                    <CalendarIcon className={classes.calendarToggleIcon} />
                  </Zoom>
                </div>
              </IconButton>
            </div>
            {/* SORT SHOOTS */}
            {/* <React.Fragment>
              <SortBy
                sort={props.sort}
                setSortFilter={props.setSortFilter}
                disabled={props.isCalendarView || props.isListView}
                // onClickItem={props.onClick}
              />
            </React.Fragment> */}

            {/* FILTER SHOOTS */}
            <IconButton
              className={classes.filterButton}
              onClick={() => props.toggleFilterDialog(true)}
            >
              <Icon>tune</Icon>
            </IconButton>
            {/* FILTER BY SHOOT CREATOR */}
            {activeCompany && (
              <IconButton
                className={classes.filterButton}
                onClick={() => props.toggleCreatorFilterDialog(true)}
              >
                <Icon>person</Icon>
              </IconButton>
            )}

            {activeCompany && (
              <IconButton
                className={classes.filterButton}
                onClick={() => props.toggleFilterPreferencesDialog(true)}
              >
                <Icon>settings</Icon>
              </IconButton>
            )}

            {/* SEARCH SHOOTS */}

            {/* SEARCH SHOOTS */}
            <Hidden smDown>
              <TextField
                variant="outlined"
                value={props.search}
                onChange={e => props.searchOnChange(e)}
                label="Search Here"
                margin="dense"
              />
            </Hidden>
            <Hidden mdUp>
              <IconButton onClick={handleOpenSearchMenu}>
                <Icon>search</Icon>
              </IconButton>
              <Menu
                anchorEl={searchMenuAnchorEl}
                open={Boolean(searchMenuAnchorEl)}
                onClose={handleCloseSearchMenu}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
              >
                <MenuItem>
                  <TextField
                    variant="outlined"
                    value={props.search}
                    onChange={e => props.searchOnChange(e)}
                    label="Search"
                    margin="dense"
                  />
                </MenuItem>
              </Menu>
            </Hidden>
            {/* 
            <Hidden mdUp>
              <IconButton onClick={handleOpenSearchMenu}>
                <Icon>search</Icon>
              </IconButton>
              <Menu
                anchorEl={searchMenuAnchorEl}
                open={Boolean(searchMenuAnchorEl)}
                onClose={handleCloseSearchMenu}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                classes={{ paper: classes.searchMenuPaper }}
              >
                <Paper
                  elevation={1}
                  style={{ marginRight: 16 }}
                  className={classes.searchMenuItemPaper}
                >
                  <AutoComplete
                    value={props.search}
                    className={classes.searchShootsAutocomplete}
                    showValue
                    placeholder="Search Shoots"
                    onChange={id => props.shootSelected(id)}
                    labelKey="name"
                    // isDisabled={!context.inCompany}
                    prop={props.props}
                  />
                </Paper>
                {/* <MenuItem>
                  <AutoComplete
                    value={props.search}
                    className={classes.searchShootsAutocomplete}
                    showValue
                    placeholder="Search Shoots"
                    onChange={id => props.shootSelected(id)}
                    labelKey="name"
                    // isDisabled={!context.inCompany}
                    prop={props.props}
                  />
                </MenuItem> */}
            {/* </Menu>
            </Hidden>  */}
          </div>
        )
      }}
    />
  )
}

export default withStyles(styles)(CustomActionBar)
